import { Component, OnInit } from '@angular/core'
import { ApiService, UserInfo } from '../../services/api.service'
import { ActivatedRoute, Router } from '@angular/router'
import { filter } from 'rxjs'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  userInfo: UserInfo;

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.api.userInfo
      .pipe(
        filter(userInfo => !!userInfo.accountType)
      )
      .subscribe(userInfo => {
        this.userInfo = userInfo;

        const redirectUrl = this.route.snapshot.queryParamMap.get('redirect');
        if (redirectUrl) {
          location.href = redirectUrl;
        }
      });
  }
}
